// Function to dispatch a custom event when an element with a specific ID is added
function dispatchIdAddedEvent(node)
{
    const event = new CustomEvent('onElementAdded',
    {
        detail:
        {
            id: node.id,
            classList: node.classList,
            node: node
        }
    });

    document.dispatchEvent(event);
}

// Create a new MutationObserver instance
const observer = new MutationObserver((mutationsList) =>
{
    for (const mutation of mutationsList)
    {
        // Check if the mutation is of type 'childList' (i.e., nodes have been added or removed)
        if (mutation.type !== 'childList')
            continue;

        // Loop through the added nodes
        for (const node of mutation.addedNodes)
        {
            // Only check element nodes (skip text nodes, etc.)
            if (node.nodeType !== Node.ELEMENT_NODE)
                continue;
                
            // Dispatch the custom event if the node has an ID
            dispatchIdAddedEvent(node);
        }
    }
});

// Specify what to observe
const config = { childList: true, subtree: true };

// Start observing the entire document
observer.observe(document.body, config);

//export default observer;